"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTranslation = void 0;
const axios_1 = __importDefault(require("axios"));
const dexie_1 = __importDefault(require("dexie"));
const constants_1 = require("./constants");
const db = new dexie_1.default('TranslationDB');
db.version(1).stores({
    translations: 'project',
});
const getEdgeConfig = async () => {
    try {
        const response = await axios_1.default.get(constants_1.CONFIG_URL || '');
        return response?.data;
    }
    catch (error) {
        console.error(error);
    }
};
const initDBfromAPI = async (i18nVersion, projectId, env) => {
    const queryParams = [];
    let domain;
    if (env) {
        queryParams.push(`env=${env}`);
    }
    if (i18nVersion) {
        queryParams.push(`version=${i18nVersion[projectId || '']}`);
    }
    if (env === 'production') {
        domain = 'https://hermes.gustforward.com';
    }
    else {
        domain = 'hermes';
    }
    const response = await axios_1.default.get(`${domain}/api/v1/translation${queryParams.length > 0 ? `?${queryParams.join('&')}` : ''}` || '', {
        headers: {
            'x-api-key': process.env.API_KEY,
        },
    });
    const { translations } = response?.data || {};
    const translationObj = translations.reduce((result, item) => {
        result[item.module] = {
            ...result[item.module],
            [item.key]: item.translations,
        };
        return result;
    }, {});
    Object.entries(translationObj).forEach(async ([key, value]) => {
        delete value['_id'];
        await db.translations.put({
            ...value,
            project: key,
            version: i18nVersion?.[projectId || ''] || '',
        }, key);
    });
    return translationObj;
};
async function fetchTranslation(projectId, env) {
    try {
        let translationObj;
        const config = await getEdgeConfig();
        const { i18nVersion } = config?.items || {};
        const exist = await dexie_1.default.exists('TranslationDB');
        if (exist) {
            const dbValue = await db.translations.get(projectId);
            if (dbValue?.version < (i18nVersion?.[projectId || ''] || 2)) {
                translationObj = initDBfromAPI(i18nVersion, projectId, env);
            }
            else {
                translationObj = dbValue;
            }
        }
        else {
            translationObj = initDBfromAPI(i18nVersion, projectId, env);
        }
        return translationObj || undefined;
    }
    catch (error) {
        console.error(error);
    }
}
exports.fetchTranslation = fetchTranslation;
//# sourceMappingURL=translation.js.map